import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppConfigService } from 'src/app/config/appconfig.service';
import { PaymentMethodModel } from 'src/app/models/payment-method.model';
import { RecurringPaymentRequest } from 'src/app/models/payment.model';
import { LoaderService } from 'src/app/services/loader.service';
import { PaymentService } from 'src/app/services/payment.service';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-payment-confirmation',
  templateUrl: './payment-confirmation.component.html',
  styleUrls: ['./payment-confirmation.component.scss']
})
export class PaymentConfirmationComponent implements OnInit {


  payment: PaymentMethodModel;
  paymentFrequency: any;
  isPendingPolicy: boolean;
  myform:FormGroup;
  recurringSignUpFailed: boolean = false;
  userInfo: any;
  hideRecurringPayment: boolean = false;
  isGracePayment: boolean = false;

  constructor(private router: Router, private fb:FormBuilder,
    private paymentService:PaymentService, private loaderService:LoaderService, private storageService:StorageService, private config: AppConfigService) {
    this.myform = this.fb.group({
      paymentFrequency:['', [Validators.required]]
    });
    this.isGracePayment = this.config.getIsGracePayment();
    let userInfo = this.storageService.getUserInfo();
    if(userInfo == null){
       this.router.navigateByUrl('/policy-search');
    } else{
      this.userInfo = userInfo;
    }
    let savedPaymentMethods = this.userInfo?.paymentMethods?.[0]?.savedPaymentMethods;
    if(savedPaymentMethods){
      for(let paymentMethod of savedPaymentMethods){
        if(paymentMethod.recurringMethod){
          this.hideRecurringPayment = true;
        }
      }
    }
    let paymentMethodData = this.storageService.getSelectedPaymentMethod();
    if(paymentMethodData == null){
       this.router.navigateByUrl('/payment-method');
    } else{
      let paymentMethod = paymentMethodData.paymentMethod;
      let bankDetails, creditCard = null;
      this.payment={
        paymentMethod,
        creditCard,
        bankDetails
      }
      if(paymentMethod =='Bank Account'){
        this.payment.bankDetails=paymentMethodData.paymentToken.paymentTxnDetails.electronicFunds.electronicFundsTransfer;
      } else if(paymentMethod =='Credit Card'){
        this.payment.creditCard = paymentMethodData.additionalDetails.additionalCardInfo;
      }  
    } 

    let isPendingPolicy = this.storageService.getIsPendingPolicy();
    if(!this.isGracePayment && isPendingPolicy == null){
      this.router.navigateByUrl('/home');
    } else{
      this.isPendingPolicy = isPendingPolicy ?? false;
    }
  }

  ngOnInit(): void {
    this.loaderService.hideLoader();
  }
  
  onSubmit(){
    if(this.myform.valid){
      this.recurringSignUpFailed = false;
      this.loaderService.showLoader();
      let request : RecurringPaymentRequest= {
          policyNumber: this.userInfo.policyNumber,
          billingFrequency: this.myform.get('paymentFrequency').value,
          billingMethod: "ACH"
      }
      this.paymentService.signupForRecuringPayment(request).subscribe({
        next: (response: any) => {
          this.storageService.setPaymentFrequency(this.myform.get('paymentFrequency').value);
          this.router.navigateByUrl('/recurring');
        },
        error: (error) => {
          this.recurringSignUpFailed = true;
          this.loaderService.hideLoader();
          window.scrollTo(0, 0);
        }
      })
    } else{
      this.myform.markAllAsTouched();
      window.scrollTo(0, 0);
    }
  }

  signUp() {
    window.open('https://www.nationwide.com/my-account-login', '_blank');
  }

  onViewPaymentDetails() {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/view'])
    );

    window.open(url, '_blank');
  }
}
